export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9844.0e73e4be.jpg";